/**
 * ReadOnlyBanner — surfaces RD read-only-of-others mode (Q2 of
 * WORKSHOP_DASHBOARDS.md). Rendered at the top of the dashboards body
 * when the response envelope's `mode === 'read-only'`.
 */
import { Eye } from 'lucide-react';

export interface ReadOnlyBannerProps {
  regionName: string;
}

export function ReadOnlyBanner({ regionName }: ReadOnlyBannerProps) {
  return (
    <div className="nb-readonly" role="status">
      <Eye size={15} />
      <span>
        You&rsquo;re viewing <strong>{regionName}</strong> in read-only mode — edits require
        Regional Director access to this region.
      </span>
    </div>
  );
}
